import { invariant, isPrimitive } from '../../utils/utils';
export class SerializrType_primitive {
    serializer({ value }) {
        invariant(isPrimitive(value), `this value is not primitive: ${value}`);
        return value;
    }
    deserializer({ json: jsonValue }) {
        if (!isPrimitive(jsonValue)) {
            throw `[serializr] this value is not primitive: ${jsonValue}`;
        }
        return jsonValue;
    }
}
export const primitive = new SerializrType_primitive();
